import script from "./NewDriverPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NewDriverPage.vue?vue&type=script&setup=true&lang=js"

import "./NewDriverPage.vue?vue&type=style&index=0&id=568dd5e8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-568dd5e8"]])

export default __exports__